export const styles = (theme) => ({
  root: {
    height: '270mm',
    margin: '0 0 13mm',
  },
  photo: {
    margin: '25mm 0',
    width: '100%',
    height: 'auto',
  },
  title: {
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(32),
  },
  subtitle: {
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(32),
  },
});

export default styles;
